// extracted by mini-css-extract-plugin
module.exports = {"root":"contact_root__AUz2F","doodles":"contact_doodles__3JmyI","outer":"contact_outer__1tJjo","inner":"contact_inner__3MbZF","heading":"contact_heading__bU3o2"};